;(function () {
  angular
    .module('contrast.tutorial')
    .directive('tutorialArrow', function ($, $log, $window) {
      'ngInject'

      var svgContainer = null,
        svgPadding = 100,
        curveOffset = 20,
        curveAbsolute = 0,
        horizontalDisplacement = 0,
        yDisplacement = 0

      function getPositionFromRect(rect, placement, xDiff, yDiff) {
        placement = placement || 'center'
        xDiff = xDiff || 0
        yDiff = yDiff || 0

        var x, y

        if (placement.indexOf('top') > -1) {
          y = rect.top
        } else if (placement.indexOf('bottom') > -1) {
          y = rect.bottom
        } else {
          y = (rect.top + rect.bottom) / 2
        }

        if (placement.indexOf('right') > -1) {
          x = rect.right
        } else if (placement.indexOf('left') > -1) {
          x = rect.left
        } else {
          x = (rect.left + rect.right) / 2
        }

        return { x: x + xDiff, y: y + yDiff }
      }

      function getLineData(start, end, startPlacement) {
        var width = Math.abs(start.x - end.x),
          height = Math.abs(start.y - end.y),
          ratio = width / height,
          xPositive = startPlacement.indexOf('right') > -1 ? 1 : -1,
          yPositive = start.y <= end.y ? 1 : -1

        var startPoint = {
          x: start.x > end.x ? width : 0,
          y: start.y > end.y ? height : 0
        }
        var middlePoint = {
          x:
            width / 2 +
            curveOffset / (xPositive * ratio) +
            xPositive * curveAbsolute,
          y:
            height / 2 +
            curveOffset * (yPositive * ratio) -
            yPositive * curveAbsolute
        }
        var endPoint = {
          x: start.x > end.x ? 0 : width,
          y: start.y > end.y ? 20 : height
        }

        return [startPoint, middlePoint, endPoint]
      }

      return {
        restrict: 'C',
        scope: {
          endpoint: '@',
          startPlacement: '@',
          endPlacement: '@',
          horizontalDisplacement: '=',
          yDisplacement: '=',
          curve: '=',
          curveAbsolute: '=',
          zIndex: '='
        },
        link: function ($scope, element) {
          var zIndex = $scope.zIndex,
            isGray = element.hasClass('tutorial-arrow-gray')
          $scope.startRect = element[0].getBoundingClientRect()
          $scope.endRect = null

          if ($scope.curve && !isNaN($scope.curve)) {
            curveOffset = $scope.curve
          }

          if ($scope.curveAbsolute && !isNaN($scope.curveAbsolute)) {
            curveAbsolute = $scope.curveAbsolute
          }

          if (
            $scope.horizontalDisplacement &&
            !isNaN($scope.horizontalDisplacement)
          ) {
            horizontalDisplacement = $scope.horizontalDisplacement
          }

          if ($scope.yDisplacement && !isNaN($scope.yDisplacement)) {
            yDisplacement = $scope.yDisplacement
          }

          var endWatchers = []

          $scope.$watch(
            function () {
              return element[0].getBoundingClientRect().top
            },
            function (newValue) {
              if (angular.isNumber(newValue)) {
                $scope.startRect = element[0].getBoundingClientRect()
              }
            }
          )

          $scope.$watch(
            function () {
              return element[0].getBoundingClientRect().left
            },
            function (newValue) {
              if (angular.isNumber(newValue)) {
                $scope.startRect = element[0].getBoundingClientRect()
              }
            }
          )

          $scope.$watch(
            function () {
              return $($scope.endpoint).length
            },
            function (newValue, oldValue) {
              if (angular.isNumber(newValue) && newValue > 0) {
                $scope.endRect = $($scope.endpoint)[0].getBoundingClientRect()

                var watch1 = $scope.$watch(
                  function () {
                    return $($scope.endpoint)[0].getBoundingClientRect().top
                  },
                  function (newValue) {
                    if (angular.isNumber(newValue)) {
                      $scope.endRect = $(
                        $scope.endpoint
                      )[0].getBoundingClientRect()
                    }
                  }
                )
                var watch2 = $scope.$watch(
                  function () {
                    return $($scope.endpoint)[0].getBoundingClientRect().left
                  },
                  function (newValue) {
                    if (angular.isNumber(newValue)) {
                      $scope.endRect = $(
                        $scope.endpoint
                      )[0].getBoundingClientRect()
                    }
                  }
                )
                endWatchers = [watch1, watch2]
              } else if (angular.isNumber(oldValue) && oldValue > 0) {
                endWatchers[0]()
                endWatchers[1]()
                removeLine()
              }
            }
          )

          $scope.$watch('startRect', function (newVal) {
            if (newVal) {
              redrawLine()
            }
          })
          $scope.$watch('endRect', function (newVal) {
            if (newVal) {
              redrawLine()
            }
          })
          $window.addEventListener('resize', onresize)

          function onresize() {
            $scope.startRect = element[0].getBoundingClientRect()
            try {
              $scope.endRect = $($scope.endpoint)[0].getBoundingClientRect()
            } catch (e) {
              $log.warn(e)
            }

            redrawLine()
          }

          element.on('$destroy', function () {
            removeLine()
            $window.removeEventListener('resize', onresize)
          })

          function removeLine() {
            if (svgContainer) {
              $(svgContainer[0][0]).remove()
              svgContainer = null
            }
          }

          function getArrowLength(start, end) {
            //get distance
            var dist = Math.sqrt(
                Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2)
              ),
              length = 50

            //arrow length between 20 and 50
            if (dist < 200) {
              length -= dist > 50 ? 30 - (dist - 50) / 5 : 30
            }

            return length
          }

          function getArrows(end, middle, length) {
            var angle = Math.PI / 6,
              endX = end.x + svgPadding,
              endY = end.y + svgPadding,
              refAngle = -(
                Math.PI + Math.atan2(end.y - middle.y, end.x - middle.x)
              )

            var arrow1 = [
              {
                x: endX + length * Math.cos(refAngle - angle),
                y: endY - length * Math.sin(refAngle - angle)
              },
              {
                x: endX + (length / 2) * Math.cos(refAngle - angle / 2),
                y: endY - (length / 2) * Math.sin(refAngle - angle / 2)
              },
              {
                x: endX,
                y: endY
              }
            ]

            var arrow2 = [
              {
                x: endX + length * Math.cos(refAngle + angle),
                y: endY - length * Math.sin(refAngle + angle)
              },
              {
                x: endX + (length / 2) * Math.cos(refAngle + angle / 2),
                y: endY - (length / 2) * Math.sin(refAngle + angle / 2)
              },
              {
                x: endX,
                y: endY
              }
            ]

            return [arrow1, arrow2]
          }

          function redrawLine() {
            if ($scope.startRect && $scope.endRect) {
              var start = getPositionFromRect(
                  $scope.startRect,
                  $scope.startPlacement
                ),
                end = getPositionFromRect(
                  $scope.endRect,
                  $scope.endPlacement,
                  horizontalDisplacement,
                  yDisplacement
                )

              var top = start.y > end.y ? end.y : start.y,
                left = start.x > end.x ? end.x : start.x

              var lineData = getLineData(start, end, $scope.startPlacement),
                arrows = getArrows(
                  lineData[2],
                  lineData[1],
                  getArrowLength(start, end)
                )

              var lineFunction = d3.svg
                .line()
                .x(function (d) {
                  return d.x + svgPadding
                })
                .y(function (d) {
                  return d.y + svgPadding
                })
                .interpolate('basis')
              var arrowLineFunction = d3.svg
                .line()
                .x(function (d) {
                  return d.x
                })
                .y(function (d) {
                  return d.y
                })
                .interpolate('basis')

              if (svgContainer) {
                removeLine()
              }

              svgContainer = d3
                .select('body')
                .append('svg')
                .attr('class', isGray ? ' tutorial-gray' : 'svg-shadow')
                .attr(
                  'style',
                  'top: ' +
                    (top - svgPadding) +
                    'px;' +
                    'left: ' +
                    (left - svgPadding) +
                    'px;' +
                    'position: absolute;' +
                    'z-index: ' +
                    (zIndex ? zIndex : 10000000) +
                    ';' +
                    'pointer-events: none;' +
                    'width: auto;' +
                    'height: auto;' +
                    'overflow-x: visible;' +
                    'overflow-y: visible;'
                )

              //line
              svgContainer
                .append('path')
                .attr('d', lineFunction(lineData))
                .attr('stroke', getStrokeColor())
                .attr('stroke-width', getStrokeWidth())
                .attr('fill', 'none')

              //arrow head line 1
              svgContainer
                .append('path')
                .attr('d', arrowLineFunction(arrows[0]))
                .attr('stroke', getStrokeColor())
                .attr('stroke-width', getStrokeWidth())
                .attr('fill', 'none')
              //arrow head line 2
              svgContainer
                .append('path')
                .attr('d', arrowLineFunction(arrows[1]))
                .attr('stroke', getStrokeColor())
                .attr('stroke-width', getStrokeWidth())
                .attr('fill', 'none')

              //for rounded edges
              var circle = svgContainer
                .selectAll('circle')
                .data([
                  lineData[0],
                  lineData[2],
                  arrows[0][0],
                  arrows[0][2],
                  arrows[1][0],
                  arrows[1][2]
                ])

              var circleEnter = circle.enter().append('circle')
              circleEnter.attr('cy', function (d, i) {
                return d.y + (i < 2 ? svgPadding : 0)
              })
              circleEnter.attr('cx', function (d, i) {
                return d.x + (i < 2 ? svgPadding : 0)
              })
              circleEnter.attr('r', getStrokeWidth() / 2)
              circleEnter.attr('style', 'fill:' + getStrokeColor() + ';')
            }
          }

          function getStrokeColor() {
            return isGray ? '#bfbfbf' : 'white'
          }

          function getStrokeWidth() {
            return isGray ? 4 : 6
          }
        }
      }
    })
})()
